import { BonusCreditType } from '../bonusCreditType';
export const creditInfoSchema = {
    $id: 'urn:wisepipe-usages-domain:CreditInfo',
    type: 'object',
    properties: {
        credit: { type: 'number' },
        completedSurvey: { type: 'boolean' },
        addedBonusCreditTypes: { type: 'array', items: { type: 'string', enum: Object.values(BonusCreditType) } }
    },
    required: ['credit']
};
//# sourceMappingURL=creditInfo.js.map